import React from 'react';

function ProjectNotFound({ title }) {
  return (
    <div data-testid="title">The following page cannot be found: {title}</div>
  );
}

export default ProjectNotFound;
